/*!

=========================================================
* BootstrapVue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Vue from 'vue'
import DashboardPlugin from './plugins/dashboard-plugin'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'

// router setup
import router from './routes/router'
import Pusher from 'pusher-js';

// plugin setup
Vue.use(DashboardPlugin)
Vue.use(VueAxios, axios)

axios.defaults.withCredentials = true
axios.defaults.baseURL = (process.env.NODE_ENV !== 'production')? '/api/' : 'https://dashboard-api.sitebooster.nl'

Pusher = require('pusher-js')
// Enable pusher logging - don't include this in production
Pusher.logToConsole = (process.env.NODE_ENV !== 'production')

window.pusher = new Pusher('5fc4dd42fde6f32bf25a', {
  cluster: 'eu'
});

store.dispatch('auth/me').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
